import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import SurveySearchPage from './pages/survey/search/SurveySearchPage';
import UploadPage from './pages/survey/UploadPage';
import LoginPage from './pages/iam/LoginPage';
import ChangePasswordPage from './pages/iam/ChangePasswordPage';
import MangeUsersPage from './pages/iam/ManageUsersPage';
import UploadVideo from './pages/transcription/UploadVideoPage';
import PrivateRoute from './PrivateRoute';
import TestTranscription from './pages/transcription/TestVideoTranscription';
import ManageStartupPage from './pages/survey/ManageStartupPage';
import DownloadTranscription from './pages/transcription/DownloadAnalysisPage';
import UploadAnalysisPage from './pages/transcription/UploadAnalysisPage';
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public route, no AuthProvider */}
        <Route path="/iam/login" element={<LoginPage />} />

        {/* Wrap protected routes inside AuthProvider */}
        <Route
          path="/*"
          element={
            <AuthProvider>
              <Routes>
                <Route
                  path="surveys/manage-startups"
                  element={
                    <PrivateRoute>
                      <ManageStartupPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="surveys/manage-surveys"
                  element={
                    <PrivateRoute>
                      <SurveySearchPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="surveys/upload"
                  element={
                    <PrivateRoute>
                      <UploadPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="video/analysis/upload-videos"
                  element={
                    <PrivateRoute>
                      <UploadVideo />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="video/analysis/upload-analysis"
                  element={
                    <PrivateRoute>
                      <UploadAnalysisPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="video/analysis/download"
                  element={
                    <PrivateRoute>
                      <DownloadTranscription />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/test/transcription"
                  element={
                    <PrivateRoute>
                      <TestTranscription />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="iam/change-password"
                  element={
                    <PrivateRoute>
                      <ChangePasswordPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="iam/manage-users"
                  element={
                    <PrivateRoute>
                      <MangeUsersPage />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="*"
                  element={<Navigate to="/iam/login" replace />}
                />
              </Routes>
            </AuthProvider>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
